import { MVP_ENABLED } from 'config';
import { StyledDiv } from 'interfaces';
import { useClient } from 'modules/settings/providers/ClientProvider';
import Link from 'next/link';
import { Flex, Item } from 'react-flex-ready';
import Container from 'ui/Container';
import LogoFooter from 'ui/Logos/LogoFooter';
import { VariantTypes } from 'ui/uiTypes';

import footerData from './footerData';
import { Address, Email, Links, Phone, SubItem, Wrapper } from './styles';

const Footer = () => {
  const { client } = useClient();
  return (
    <Wrapper>
      <Container as={Flex as StyledDiv} align="flex-start">
        <Item col={8} colTablet={12} colMobile={12} gap={2}>
          <Link href={MVP_ENABLED ? '/dashboard' : '/'}>
            <LogoFooter variant={VariantTypes.SECONDARY} client={client} />
          </Link>
          <Address>
            {footerData(client).address.map((elem, i) => (
              <p key={i}>{elem}</p>
            ))}
          </Address>
          <Phone href={`tel:${footerData(client).phone}`}>
            {footerData(client).phone}
          </Phone>
          <Email href={`mailto:${footerData(client).email}`}>
            {footerData(client).email}
          </Email>
        </Item>
        <Item col={4} colTablet={12} colMobile={12} gap={2}>
          <Links>
            {footerData(client).links?.map((link) => (
              <SubItem key={link.title}>
                <a target="_blank" href={link.href}>
                  {link.title}
                </a>
              </SubItem>
            ))}
          </Links>
        </Item>
      </Container>
    </Wrapper>
  );
};

export default Footer;
